import { Component } from '@angular/core'

@Component({
  selector: 'kit-antd-tooltip-example',
  templateUrl: './tooltip.component.html',
})
export class KitAntdTooltipExampleComponent {}
